import { StatusGroup } from '@app/_api/dto';
import { SelectOptionGroup, SelectOptionModel } from '@app/_api/model';

export class StatusGroupUtil {
  static asOptionGroups(statusGroups: StatusGroup[]): SelectOptionGroup<StatusGroup>[] {
    return [
      {
        title: 'Abteilung',
        models: statusGroups.map(this.asSelectOptionModel),
      },
    ];
  }

  private static asSelectOptionModel(statusGroup: StatusGroup): SelectOptionModel<StatusGroup> {
    return {
      name: statusGroup.name,
      object: statusGroup,
    } as SelectOptionModel<StatusGroup>;
  }
}
